// App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Table from './Table';
import MyOrders from './MyOrders';


const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate replace to="/table/" />} />
        <Route path="/table/" element={<Table />} />
        <Route path="/table/:paramTableNumber" element={<Table />} />
        <Route path="/orders/" element={<MyOrders />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;